'use client';

/**
 * PlanLensFrame — the container every lens card wears: a header band
 * (title, meta) over a body on its own surface.
 * The frame lives INSIDE the card, so a card carries its own edges wherever
 * it is placed; nothing here reads data or computes anything.
 *
 * @component_role: Card
 * @component_type: Card Chrome
 * @domain: Canvas / Obeya
 * @layer: presentation
 */

import type { ReactNode } from 'react';
import { text } from '@/lib/design/tokens';
import { cn } from '@/lib/utils/cn';

interface Props {
  title: string;
  meta?: string;
  children: ReactNode;
}

export function PlanLensFrame({ title, meta, children }: Props) {
  return (
    <section className="rounded-xl border border-border bg-card shadow-sm overflow-hidden">
      <header className="flex items-center flex-wrap gap-x-3 gap-y-1 px-5 py-3 bg-muted/40 border-b border-border">
        <h3 className={cn(text.heading)}>{title}</h3>
        {meta && <span className={cn(text.muted)}>{meta}</span>}
      </header>
      <div className="p-5">{children}</div>
    </section>
  );
}
